import { render, staticRenderFns } from "./MarketingInfo.vue?vue&type=template&id=04728239&scoped=true&"
import script from "./MarketingInfo.vue?vue&type=script&lang=ts&"
export * from "./MarketingInfo.vue?vue&type=script&lang=ts&"
import style0 from "./MarketingInfo.vue?vue&type=style&index=0&id=04728239&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.14_webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04728239",
  null
  
)

export default component.exports